<template>
  <div class="searchbar_holder">
    <font-awesome-icon class="searchbar_icon" :icon="['far', 'search']" />
    <input
      ref="searchbar"
      :value="value"
      class="inbox_item_header__searchbar"
      :placeholder="placeholder"
      type="search"
      @input="onInput"
      @blur="onBlur"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import InputBase from "./mixins/InputBase";

library.add(faSearch);

export default {
  name: "SearchBar",
  mixins: [InputBase],
  components: {
    FontAwesomeIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    onInput: debounce(function ($event) {
      this.$emit("input", $event.target.value);
    }, 500),
    onBlur($event) {
      this.$emit("blur", $event);
    },
    clearSearchbar() {
      const searchbar = this.$refs.searchbar;
      searchbar.value = "";
      this.inputValue = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style_variables/style_variables.scss";

.searchbar_holder {
  background: $grey_alabaster;
  border: 1px solid $grey_alabaster;
  border-radius: 6px;
  height: 44px;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
}

.inbox_item_header__searchbar {
  @extend %body2_style;
  font-size: 1rem;
  color: $black;
  width: 100%;
  height: 100%;
  background: transparent;
  border: 0;
  outline: 0;
  padding-right: 12px;

  &::placeholder {
    color: $grey_abbey;
  }

  &::-webkit-search-cancel-button {
    -webkit-appearance: none;
    height: 14px;
    width: 14px;
    margin-left: 0.4em;
    background: linear-gradient(
        to top left,
        transparent 43%,
        $grey_french 43%,
        $grey_french 57%,
        transparent 57%
      ),
      linear-gradient(
        to top right,
        transparent 43%,
        $grey_french 43%,
        $grey_french 57%,
        transparent 57%
      );
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: cover;
  }
}

.searchbar_icon {
  width: 44px;
  padding: 0 8px 0 12px;
}
</style>
